import { type FC } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useIntl } from "react-intl";

export interface LoadingProps {
	readonly hideLabel?: boolean;
	readonly size?: "small" | "medium" | "large";
	readonly className?: string;
	readonly message?: string;
	readonly "data-testid"?: string;
}

const SIZE_MAP = {
	small: 24,
	medium: 40,
	large: 56,
} as const;

export const Loading: FC<LoadingProps> = ({
	hideLabel = false,
	size = "medium",
	className,
	message,
	"data-testid": dataTestId,
}) => {
	const intl = useIntl();

	const circularProgressSize = SIZE_MAP[size] || SIZE_MAP.medium;
	const label = message ?? intl.formatMessage({ id: "Loading", defaultMessage: "Loading" });

	return (
		<Box
			className={className}
			data-testid={dataTestId}
			sx={{
				height: "200px",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				flexDirection: "column",
				gap: 2,
			}}
		>
			<CircularProgress data-cy="loader" data-testid="loader" size={circularProgressSize} />
			{hideLabel === false && <Typography variant="body1">{label}</Typography>}
		</Box>
	);
};
